import { Component, EventEmitter, Input, OnInit, Output } from '@angular/core';
import { ThemeActionType } from '../../../../../shared/constants/question.constants';

@Component({
  selector: 'app-question-theme',
  templateUrl: './question-theme.component.html',
  styleUrls: ['./question-theme.component.less']
})
export class QuestionThemeComponent implements OnInit {
  @Input() theme: string
  @Output() onThemeUpdate = new EventEmitter<string>()

  actionType: number

  constructor() { }

  ngOnInit() {
    this.assignActionType()
  }

  assignActionType = () => this.actionType = this.theme ? ThemeActionType.VIEW : ThemeActionType.EMPTY

  addNewTheme(): void {
    this.actionType = ThemeActionType.NEW
    setTimeout(() => {
      document.getElementById('txtTheme').focus()
    }, 100)
  }

  changeOnEnter(): void {
    this.actionType = ThemeActionType.VIEW
  }

  changeOnBlur(): void {
    if(this.actionType !== ThemeActionType.VIEW){
      this.actionType = ThemeActionType.EMPTY
      this.theme = null
      this._onThemeUpdate()  
    }
  }

  removeTheme(): void {
    this.actionType = ThemeActionType.EMPTY
    this.theme = null
    this._onThemeUpdate()
  }

  _onThemeUpdate(){
    this.onThemeUpdate.emit(this.theme)
  }

  get ThemeActionType(): typeof ThemeActionType {
    return ThemeActionType
  }

}





// WEBPACK FOOTER //
// ./src/app/routes/surveys/new-survey/questions-tab/question-theme/question-theme.component.ts